import React, { useState, useEffect } from 'react';
import {
  Box, Button, Tooltip, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper,
  Typography, Breadcrumbs, Link, TableSortLabel, Radio, RadioGroup, FormControlLabel, FormControl, Autocomplete, Pagination, Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { usePermissions } from '../../../GlobalFunction/userPermissions';
import axiosInstance from '../../../lib/axios';
import AddIcon from '@mui/icons-material/Add';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import * as XLSX from 'xlsx';
import { visuallyHidden } from '@mui/utils';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import ReplayIcon from '@mui/icons-material/Replay';
import LoadingSpinner from "../../LoadingSpinner";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TodayEnqListPopup from './TodayEnqListPopup';
import BulkUpdateEnq from './BulkUpdateEnq';
import { selectGlobalProperty } from '../../../redux/propertySlice';
import { useSelector } from 'react-redux';

const EnquiryTable = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [allRows, setAllRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const permissions = usePermissions("Enquiry");

  const { AddRec = "0" } = permissions || {};
  const {EditRec = "0"} = permissions || {};
  const navigate = useNavigate();
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const UserId = sessionStorage?.getItem('UserId');
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();
  const [statusFilter, setStatusFilter] = useState("Open");
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  const [openTodayEPopup, setOpenTodayEPopup] = useState(false)
  const [openBulkUpdate, setOpenBulkUpdate] = useState(false)
  const [columnWidths, setColumnWidths] = useState({
    FlwEmpNm: 85,
    EnqNo: 90,
    EnqDt: 80,
    LastFlwDt: 100,
    EnqTypeNm: 70,
    VisitSt: 40,
    Remark: 130,
    NextFlwDt: 100,
    EnqBy: 95,
    EnqFor: 85,
    MobileNo: 90,
    OcupntMob: 90,
    Tenure: 60,
    SourceBy: 80,
    SourceName: 80,
    VisitEmpNm: 90,
    VisitRemark: 150,
    BrokerName: 80,
    EmailId: 150,
    CheckInDt: 100,
    RoomTypeName: 90,
    VisitDt: 80,
    SemesterName: 80,
    CourseName: 70,
    DesiName: 90,
    Status: 50
  });
  const [followByOptions, setFollowByOptions] = useState([]);
  const [selectedFollowBy, setSelectedFollowBy] = useState(null);
  const [selectedRows, setSelectedRows] = useState(new Set())
   
  const columns = [
    { id: 'FlwEmpNm', label: 'Follow By', width: 85 },
    { id: 'EnqNo', label: 'Enquiry No', width: 85 },
    { id: 'EnqDt', label: 'EnqDate', width: 100 },
    { id: 'LastFlwDt', label: 'LastFollowUp', width: 120 },
    { id: 'Status', label: 'Status', width: 50 },
    { id: 'EnqTypeNm', label: 'EnqType', width: 100 },
    { id: 'VisitSt', label: 'Visit', width: 70 },
    { id: 'Remark', label: 'Remark', width: 150 },
    { id: 'NextFlwDt', label: 'NextFollowUp', width: 120 },
    { id: 'EnqBy', label: 'EnqBy', width: 100 },
    { id: 'EnqFor', label: 'EnqFor', width: 100 },
    { id: 'MobileNo', label: 'Mobile', width: 120 },
    { id: 'OcupntMob', label: 'OcupntMob', width: 120 },
    { id: 'Tenure', label: 'Tenure', width: 60 },
    { id: 'SourceBy', label: 'Source By', width: 80 },
    { id: 'SourceName', label: 'Source', width: 90 },
    { id: 'VisitEmpNm', label: 'VisitWith', width: 120 },
    { id: 'VisitRemark', label: 'VisitRemark', width: 200 },
    { id: 'BrokerName', label: 'Broker', width: 120 },
    { id: 'EmailId', label: 'EmailId', width: 150 },
    { id: 'CheckInDt', label: 'CheckIn Date', width: 120 },
    { id: 'RoomTypeName', label: 'RoomType', width: 90 },
    { id: 'VisitDt', label: 'Visit Date', width: 100 },
    { id: 'SemesterName', label: 'Semester', width: 120 },
    { id: 'CourseName', label: 'Course', width: 120 },
    { id: 'DesiName', label: 'Designation', width: 120 },
    // { id: 'Status', label: 'Status', width: 100 }
  ];
  const userName = localStorage.getItem("userName")?.trim();
  useEffect(() => {
    if (followByOptions.length > 0) {
      const matchedOption = userName
        ? followByOptions.find(option =>
          option.UserName?.trim() === userName
        )
        : null;
      setSelectedFollowBy(matchedOption || followByOptions[0]);
    }
  }, [followByOptions, userName]);
  const handleFollowByChange = (event, newValue) => {
    setSelectedFollowBy(newValue);
  };

  useEffect(() => {
    fetchPropertyOptions();
  }, []);

  const fetchPropertyOptions = async () => {
    try {
      const response = await axiosInstance.post(`PropertyMst/GetPropertyMstUserwisedrp`, {
        UserId: UserId,
        Flag: "All"
      });

      if (response.data.Status === 0 && response.data.Data) {
        const options = response.data.Data;
        setPropertyOptions(options);
        if (options.length > 0) {
          const defaultProperty = options[0];
          setSelectedProperty(defaultProperty);
          fetchFollowBy(defaultProperty.Id);
        }
      }
    } catch (error) {
      console.error("Error fetching properties", error);
    }
  };

  const fetchEnquiry = async () => {
    if (!selectedProperty) return;

    setIsLoading(true);
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}TrnEnq/GetTrnEnqDashBoard?currentPage=1&limit=15`,
        {
          PageNumber: 1,
          PageSize: 15,
          SearchText: '',
          PropId: selectedProperty.Id,
          Flag: statusFilter,
          "FlwUserId": selectedFollowBy?.FlwUserId || ""
        }
      );

      if (response.data.Status === 0 && response.data.Data) {
        const formattedData = response.data.Data.map(enquiry => ({
          ...enquiry,
          EnqType: enquiry.EnqType || '',
          EnqDt: enquiry.EnqDt ? moment(enquiry.EnqDt).format('DD-MM-YYYY') : '',
          NextFlwDt: enquiry.NextFlwDt ? moment(enquiry.NextFlwDt).format('DD-MM-YYYY') : '',
          CheckInDt: enquiry.CheckInDt ? moment(enquiry.CheckInDt).format('DD-MM-YYYY') : '',
          VisitDt: enquiry.VisitDt ? moment(enquiry.VisitDt).format('DD-MM-YYYY') : '',
          LastFlwDt: enquiry.LastFlwDt ? moment(enquiry.LastFlwDt).format('DD-MM-YYYY') : '',
          VisitSt: enquiry.VisitSt === "Y" ? "Yes" : enquiry.VisitSt === "N" ? "No" : "",
          // Status: enquiry.Status === null ? '' : (enquiry.Status == 1 ? 'Active' : 'Inactive'),
          BookNo: enquiry.BookNo || '',
          Status: enquiry.Status === "0" ? 'Cancel' :
            enquiry.Status === "1" ? 'Open' :
              enquiry.Status === "5" ? 'Close' :
                enquiry.Status || 'Unknown'
        }));
        setAllRows(formattedData);
        setPage(0); // Reset to first page when new data is loaded
      } else {
        setAllRows([]);
      }
    } catch (error) {
      setAllRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePermittedClick = () => {
    if (AddRec === "1") {
      navigate('/enquiry');
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const filteredRows = React.useMemo(() => {
    let filtered = allRows;

    if (globalSearchTerm) {
      filtered = filtered.filter(row =>
        Object.values(row).some(value =>
          value && value.toString().toLowerCase().includes(globalSearchTerm.toLowerCase())
        )
      );
    }

    filtered = filtered.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });

    return filtered;
  }, [searchTerms, allRows, globalSearchTerm]);


  const sortedRows = React.useMemo(() => {
    return [...filteredRows].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue < bValue) {
        return order === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [filteredRows, order, orderBy]);

  const paginatedRows = React.useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return sortedRows.slice(startIndex, endIndex);
  }, [sortedRows, page, rowsPerPage]);

  // const handleRowDoubleClick = (row) => {
  //   setSelectedRows(prev => {
  //     const newSet = new Set(prev);
  //     newSet.add(row.EnqId);
  //     return newSet;
  //   });
  //   sessionStorage.setItem('enquiryFormData', JSON.stringify({
  //     EnqId: row,
  //     mode: 'view'
  //   }));
  //   window.open('/enquiry', '_blank');
  // };

  const handleRowDoubleClick = (row) => {
    const enqId = row.EnqId || row.id;

    sessionStorage.setItem('enquiryFormData', JSON.stringify({
      EnqId: enqId,
      mode: 'view'
    }));

    sessionStorage.removeItem('followupFormData');
    window.open('/enquiry', '_blank');
  };

  const handleExportToExcel = async () => {
    setIsExporting(true);
    try {
      const exportData = sortedRows.map(enquiry => ({
        ...enquiry,
        EnqDt: enquiry.EnqDt ? moment(enquiry.EnqDt).format('DD-MM-YYYY') : '',
        NextFlwDt: enquiry.NextFlwDt ? moment(enquiry.NextFlwDt).format('DD-MM-YYYY') : '',
        CheckInDt: enquiry.CheckInDt ? moment(enquiry.CheckInDt).format('DD-MM-YYYY') : '',
        VisitDt: enquiry.VisitDt ? moment(enquiry.VisitDt).format('DD-MM-YYYY') : '',
        LastFlwDt: enquiry.LastFlwDt ? moment(enquiry.LastFlwDt).format('DD-MM-YYYY') : '',
        VisitSt: enquiry.VisitSt === "Y" ? "Yes" : enquiry.VisitSt === "N" ? "No" : "",
        Status: enquiry.Status === null ? '' : (enquiry.Status == 1 ? 'Active' : 'Inactive')
      }));

      const worksheetData = exportData.map((row) => {
        let rowData = {};
        columns.forEach((col) => {
          rowData[col.label] = row[col.id] || "";
        });
        return rowData;
      });

      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "EnquiryData");
      XLSX.writeFile(workbook, `Enquiry_${new Date().toISOString().split('T')[0]}.xlsx`);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setIsExporting(false);
    }
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };

  const handlePropertyChange = (event, newValue) => {
    setSelectedProperty(newValue);
    setPage(0);
    if (newValue) {
      fetchFollowBy(newValue.Id);
    } else {
      setFollowByOptions([]);
      setSelectedFollowBy(null);
    }
  };

  const getCellStyle = (columnId, value) => {
    if (columnId === 'EnqTypeNm') {
      switch (value) {
        case 'Hot': return { backgroundColor: '#FF0000', color: 'white', borderRadius: '4px' };
        case 'Warm': return { backgroundColor: '#FFBF00', color: 'white', borderRadius: '4px' };
        case 'Booked': return { backgroundColor: '#01bc5f', color: 'white', borderRadius: '4px' };
        case 'Refund': return { backgroundColor: '#4d7499', color: 'white', borderRadius: '4px' };
        case 'Not interested': return { backgroundColor: '#FF6347', color: 'white', borderRadius: '4px' };
        case 'Incorrect Lead': return { backgroundColor: '#922b21', color: 'white', borderRadius: '4px' };
        case 'Cold': return { backgroundColor: '#0000FF', color: 'white', borderRadius: '4px' };
        case 'Low Budget': return { backgroundColor: '#148f77', color: 'white', borderRadius: '4px' };
        case 'Others': return { backgroundColor: '#FFA500', color: 'white', borderRadius: '4px' };
        default: return {};
      }
    }
    if (columnId === 'VisitSt') {
      return value === 'Yes'
        ? { backgroundColor: '#4CAF50', color: 'white', borderRadius: '4px', textAlign: 'center' }
        : { backgroundColor: '#F44336', color: 'white', borderRadius: '4px', textAlign: 'center' };
    }
    if (columnId === 'Status') {
      switch (value) {
        case 'Cancel': return { backgroundColor: '#F44336', color: 'white', borderRadius: '4px', textAlign: 'center' };
        case 'Close': return { backgroundColor: '#4CAF50', color: 'white', borderRadius: '4px', textAlign: 'center' };
        case 'Open': return { backgroundColor: '#2196F3', color: 'white', borderRadius: '4px', textAlign: 'center' };
        default: return { textAlign: 'center' };
      }
    }
    return {};
  };

  const handleRetrieve = () => {
    if (!selectedProperty) {
      alert('Please select a property first');
      return;
    }
    if (!selectedFollowBy) {
      toast.error('Please select a follow by option');
      return;
    }
    setPage(0);
    setGlobalSearchTerm('');
    setSearchTerms({});
    setSelectedRows(new Set());
    fetchEnquiry();
  };

  const fetchFollowBy = async (propId) => {
    try {
      const response = await axiosInstance.post(
        `TrnFlwup/TrnFlwupFlwUser`,
        {
          "PropId": propId || "",
          "Flag": ""
        }
      );
      setFollowByOptions([]);
      setSelectedFollowBy(null);
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const options = response.data.Data.map(user => ({
          ...user,
          Name: user.UserName,
          FlwUserId: user.FlwUserId
        }));
        setFollowByOptions(options);
        if (options.length > 0) {
          // setSelectedFollowBy(options[0]);
        } else {
          setSelectedFollowBy(null)
        }
      }
    } catch (error) {
      console.error('Error fetching follow by options:', error);
    }
  };

  useEffect(() => {
    if (selectedProperty) {
      fetchFollowBy(selectedProperty.Id || selectedProperty);
    }
  }, []);

  const totalPages = Math.ceil(filteredRows.length / rowsPerPage);
  const handleTodayEnqClick = () => {
    setOpenTodayEPopup(true)
  }
  const BulkupdateEnquirys = () => {
   setOpenBulkUpdate(true)
  }
  return (
    <>
      <Box sx={{ maxWidth: '95vw', margin: ' auto', padding: '10px', background: 'rgb(249, 249, 249)' }}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Box
          sx={{
            backgroundColor: "#ffffff",
            padding: { xs: "8px 16px", sm: "12px 16px" },
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
            borderRadius: "12px",
            margin: "10px auto",
            maxWidth: "95%",
          }}
        >
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "column", md: "row" },
            marginBottom: { xs: "16px", sm: "16px", md: "0" }
          }}>
            <Breadcrumbs
              aria-label="breadcrumb"
              separator="›"
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                display: "flex",
                flexDirection: { xs: "column", sm: "column", md: "row" }
              }}
            >
              <Link
                color="#635bff"
                onClick={() => navigate('/dashboard')}
                underline="hover"
                sx={{ cursor: "pointer", fontWeight: "500" }}
              >
                Home
              </Link>
              <Link
                color="#635bff"
                onClick={() => navigate('/enquiry/pre-registration')}
                underline="hover"
                sx={{ cursor: "pointer", fontWeight: "500" }}
              >
                Booking(Pre-Registration)
              </Link>
              <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                Enquiry
              </Typography>
            </Breadcrumbs>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexDirection: { xs: "column", sm: "column", md: "row" },
              marginTop: { xs: "16px", sm: "16px", md: "0px" }
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexDirection: { xs: "column", md: "row" } }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="status-radio-buttons-group-label"
                  name="status-radio-buttons-group"
                  value={statusFilter}
                  onChange={handleStatusChange}
                >
                  <Typography sx={{ mr: 1, mt: 1, fontWeight: 'bold' }}>Status:</Typography>
                  <FormControlLabel value="Open" control={<Radio />} label="Open" />
                  <FormControlLabel value="Close" control={<Radio />} label="Close" />
                  <FormControlLabel value="Cancel" control={<Radio />} label="Cancel" />
                </RadioGroup>
              </FormControl>

              <Autocomplete
                options={propertyOptions}
                getOptionLabel={(option) => option?.Name || ''}
                isOptionEqualToValue={(option, value) =>
                  option?.Id === value?.Id ||
                  (option === null && value === null)
                }
                value={selectedProperty || null}
                onChange={handlePropertyChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Filter by Property"
                    variant="outlined"
                    size="small"
                    sx={{ minWidth: 200 }}
                  />
                )}
              />
              <Autocomplete
                id="follow-by-filter"
                options={followByOptions}
                getOptionLabel={(option) => option.UserName || ""}
                value={selectedFollowBy}
                onChange={handleFollowByChange}
                size="small"
                sx={{ minWidth: 200 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Follow By"
                    variant="outlined"
                    required
                  />
                )}
                isOptionEqualToValue={(option, value) => option.UserId === value?.UserId}
              />
              <Button
                size='small'
                variant='contained'
                sx={{
                  whiteSpace: 'nowrap',
                  // padding: '2px 18px',
                  borderRadius: '20px',
                  backgroundColor: '#635bff',
                  flexShrink: 0,
                  '&:hover': {
                    backgroundColor: '#524ccc'
                  },
                  width: { xs: '100%', sm: 'auto' }
                }}
                disabled={allRows.length === 0}
                onClick={handleTodayEnqClick}
              >
                Today Enquiries
              </Button>
               <Button
                size='small'
                variant='contained'
                sx={{
                  whiteSpace: 'nowrap',
                  // padding: '2px 18px',
                  borderRadius: '20px',
                  backgroundColor: '#635bff',
                  flexShrink: 0,
                  '&:hover': {
                    backgroundColor: '#524ccc'
                  },
                  width: { xs: '100%', sm: 'auto' }
                }}
                disabled={allRows.length === 0 || EditRec !== "1"}
                onClick={BulkupdateEnquirys}
              >
                Bulk Update
              </Button>
            </Box>

            <Box sx={{ display: "flex", gap: "8px", flexDirection: { xs: "column", sm: "row" } }}>
              <Button
                variant="contained"
                onClick={handleRetrieve}
                sx={{
                  backgroundColor: "#635bff",
                  color: "#ffffff",
                  padding: '1px 12px',
                  borderRadius: '20px',
                  '&:hover': {
                    backgroundColor: '#524ccc'
                  }
                }}
              >
                <ReplayIcon sx={{ fontSize: '18px', mr: 1 }} />
                Retrieve
              </Button>
              <Tooltip title={AddRec !== "1" ? "You have no permission to add record" : ""}>
                <span>
                  <Button
                    variant="contained"
                    onClick={handlePermittedClick}
                    size="small"
                    disabled={AddRec !== "1"}
                    sx={{
                      backgroundColor: "#635bff",
                      color: "#ffffff",
                      padding: "6px 16px",
                      borderRadius: '20px',
                      '&:hover': {
                        backgroundColor: '#524ccc'
                      }
                    }}
                  >
                    <AddIcon sx={{ fontSize: '18px', mr: 1 }} />
                    NEW
                  </Button>
                </span>
              </Tooltip>

              {/* <Button
                variant="contained"
                onClick={handleExportToExcel}
                sx={{
                  backgroundColor: "#635bff",
                  color: "#ffffff",
                  borderRadius: '20px',
                  '&:hover': {
                    backgroundColor: '#524ccc'
                  }
                }}
                disabled={isExporting || isLoading}
              >
                <SaveAltIcon sx={{ fontSize: '18px', mr: 1 }} />
                {isExporting ? "Exporting..." : "EXPORT"}
              </Button> */}
            </Box>
          </Box>
        </Box>

        <Paper sx={{ width: '94%', overflow: 'hidden', boxShadow: 3, margin: 'auto' }}>
          <TableContainer
            sx={{
              maxHeight: 'calc(100vh - 280px)',
              '&::-webkit-scrollbar': {
                height: '5px',
                width: '5px'
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'gray',
                borderRadius: '4px'
              }
            }}
          >
            <Table stickyHeader aria-label="sticky table" size="small" sx={{ padding: '10px' }}>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      sx={{
                        width: columnWidths[column.id] || column.width,
                        minWidth: columnWidths[column.id] || column.width,
                        backgroundColor: '#dddbff',
                        fontWeight: 'bold',
                        padding: '4px 3px',
                        borderRight: '1px solid #e0e0e0',
                        '&:last-child': {
                          borderRight: 'none'
                        }
                      }}
                      sortDirection={orderBy === column.id ? order : false}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={orderBy === column.id ? order : 'asc'}
                          onClick={() => handleRequestSort(column.id)}
                          sx={{ flexGrow: 1 }}
                          IconComponent={() => (
                            <Box component="span" sx={{
                              opacity: orderBy === column.id ? 1 : 0.3,
                              transition: 'opacity 0.2s',
                              '&:hover': { opacity: 1 }
                            }}>
                              {orderBy === column.id && order === 'asc' ? <NorthIcon sx={{ fontSize: 15, marginTop: 1 }} /> : <SouthIcon sx={{ fontSize: 15, marginTop: 1 }} />}
                            </Box>
                          )}
                        >
                          {column.label}
                          {orderBy === column.id ? (
                            <Box component="span" sx={visuallyHidden}>
                              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      </Box>
                      <Box>
                        <TextField
                          size="small"
                          variant="outlined"
                          placeholder={`Search`}
                          onChange={(e) => handleSearchChange(column.id, e.target.value)}
                          sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              backgroundColor: '#f9f9f9',
                              fontSize: '0.75rem',
                              height: '24px',
                              padding: '0 8px'
                            },
                            '& .MuiOutlinedInput-input': {
                              padding: '6px 4px'
                            }
                          }}
                        />
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} sx={{ textAlign: 'center', py: 4 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <LoadingSpinner />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : paginatedRows.length > 0 ? (
                  paginatedRows.map((row, index) => (
                    <TableRow
                      hover
                      key={index}
                      onDoubleClick={() => handleRowDoubleClick(row)}
                      sx={{
                        '&:hover': { cursor: 'pointer' },
                        ...(moment(row.FlwDt, 'DD-MM-YYYY').isSame(moment().startOf('day'), 'day') || selectedRows.has(row.EnqId)
                          ? {
                            backgroundColor: '#ccffcc !important',
                            '&:hover': {
                              backgroundColor: '#b3ffb3 !important'
                            }
                          }
                          : {
                            '&:nth-of-type(even)': {
                              backgroundColor: '#f9f9f9'
                            }
                          }
                        )
                      }}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={column.id}
                            sx={{
                              width: columnWidths[column.id] || column.width,
                              minWidth: columnWidths[column.id] || column.width,
                              maxWidth: columnWidths[column.id] || column.width,
                              padding: '1px 6px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              borderRight: '1px solid #e0e0e0',
                              '&:last-child': {
                                borderRight: 'none'
                              },
                              ...getCellStyle(column.id, value)
                            }}
                            className="no-user-select"
                          >
                            <Tooltip
                              title={value}
                              arrow placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    fontSize: '14px',
                                    maxWidth: '500px',
                                  }
                                }
                              }}
                            >
                              <span>{value}</span>
                            </Tooltip>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body2" color="textSecondary">
                        No Record Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[15, 50, 100, 500,]}
            component="div"
            count={filteredRows.length} // Use filtered count instead of totalCount
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              borderTop: '1px solid #e0e0e0',
              background: '#dddbff',
              '& .MuiTablePagination-toolbar': {
                minHeight: '52px',
                padding: '0 16px'
              },
              '& .MuiTablePagination-spacer': {
                flex: 1,
              },
              '& .MuiTablePagination-displayedRows': {
                margin: 0,
                fontSize: '0.875rem'
              },
              '& .MuiTablePagination-selectLabel': {
                margin: 0,
                fontSize: '0.875rem'
              }
            }}
            ActionsComponent={() => (
              <Stack
                direction="row"
                alignItems="center"
                sx={{
                  justifyContent: "center",
                  marginLeft: "16px",
                }}
              >
                <Pagination
                  count={totalPages}
                  page={page + 1}
                  onChange={(event, newPage) => setPage(newPage - 1)}
                  showFirstButton
                  showLastButton
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#635bff",
                      color: "#ffffff",
                    },
                  }}
                />
              </Stack>
            )}
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
            }
            labelRowsPerPage="Rows per page:"
          />
        </Paper>
        <TodayEnqListPopup
          open={openTodayEPopup}
          onClose={() => setOpenTodayEPopup(false)}
          propId={selectedProperty?.Id || selectedProperty}
          selectedFollowBy={selectedFollowBy}
        />
        <BulkUpdateEnq 
        open={openBulkUpdate}
        onClose={() => setOpenBulkUpdate(false)}
        propId={selectedProperty?.Id }
        fetchEnquiry={fetchEnquiry}
        selectedFollowBy={selectedFollowBy}
        statusFilter={statusFilter}
        />
      </Box>
    </>
  );
};

export default EnquiryTable;